module.exports = __webpack_public_path__ + "static/divider2.5314f141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/divider2.jpg
// module id = 757
// module chunks = 102538987983895